export default __webpack_public_path__ + "static/the-convenience-64e0bf8f558a73fc0914952b405e87bc.png";